import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { IFormState, ISpotRate } from '../amQuoting/types'

export const UPDATE_PRICE_REQUEST_ACTION_TYPES = generateApiActionTypes('UPDATE_PRICE_REQUEST')
export const updatePriceRequestBidInfo = (shipment: IFormState, spotRate: ISpotRate) => {
  const {
    customerQuote,
    isGeneratedQuoteStored,
    isManualAllin,
    isManualLinehaul,
    isManualQuoteStored,
    manualQuoteOverrideReason,
  } = shipment
  const { priceRequestId, rates } = spotRate
  const { allIn, linehaul } = rates

  const quoteUpdate = {
    isGeneratedQuoteStored,
    isManualQuoteStored,
    manualQuoteOverrideReason,
    customerQuote,
    priceRequestId,
    isManualLinehaul,
    isManualAllin,
    linehaul,
    allIn,
  }

  const requestData = {
    endpoint: ENDPOINTS.updatePriceRequest,
    method: 'POST',
    body: {
      updatePriceRequest: quoteUpdate,
    },
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(UPDATE_PRICE_REQUEST_ACTION_TYPES),
    },
  }
}
